import React from 'react';
import WorkingHolidayVisaSection from '../section/WorkingHolidayVisaSection';
import PageTransition from '../components/PageTransition';

const WorkingHolidayVisaPage = () => {
  return (
    <PageTransition>
      <WorkingHolidayVisaSection />
    </PageTransition>
  );
};

export default WorkingHolidayVisaPage;
